import React, {forwardRef} from 'react';
import FJIconButton from '../../../common/component/button-icon/FJIconButton';
import classNames from "classnames";

import './FJToolbarIconButton.less';

function FJToolbarIconButton(props) {

  let _onClick = (e) => {
    if (!disabled && props.onClick) {
      props.onClick(e);
    }
  };

  let _onMouseDown = (e) => {
    if (!disabled && props.onMouseDown) {
      props.onMouseDown(e);
    }
  };

  let {
    icon,
    className,
    active,
    tooltip,
    style,
    disabled = false,
    forwardRef,
  } = props;
  if (className) {
    className = className.split(/\s+/);
  }
  if (disabled) {
    active = false;
  }
  let btnClass = classNames('c-toolbar-icon-btn', className, {disabled: disabled});
  return (
    <FJIconButton tooltip={tooltip}
                  icon={icon}
                  style={style}
                  className={btnClass}
                  active={active}
                  forwardRef={forwardRef}
                  onMouseDown={_onMouseDown}
                  onClick={_onClick}/>
  )
}

export default forwardRef((props, ref) => (
  <FJToolbarIconButton {...props} forwardRef={ref}/>
));
